import fetchUserMailboxInfoFromFolderId from './helpers/fetchUserMailboxInfoFromFolderId';
import { getUserMailboxInfo, MailboxInfo } from 'owa-client-ids';
import { isPublicFolder } from 'owa-folders';
import { getGroupMailboxInfo } from 'owa-group-common';
import { getGroupIdFromTableQuery } from 'owa-group-utils';
import { TableQuery, TableView } from 'owa-mail-list-store';
import { getPublicFolderMailboxInfo } from 'owa-publicfolder-utils';

export default function getMailboxInfo(tableView: TableView): MailboxInfo {
    if (tableView) {
        return getMailboxInfoFromTableQuery(tableView.tableQuery);
    }
    return getUserMailboxInfo();
}

export function getMailboxInfoFromTableQuery(tableQuery: TableQuery): MailboxInfo {
    const groupId = getGroupIdFromTableQuery(tableQuery);

    const folderId = tableQuery && tableQuery.folderId;

    return groupId != null ? getGroupMailboxInfo(groupId) : getMailboxInfoFromFolderId(folderId);
}

export function getMailboxInfoFromFolderId(folderId: string): MailboxInfo {
    if (isPublicFolder(folderId)) {
        return getPublicFolderMailboxInfo(folderId);
    } else {
        return fetchUserMailboxInfoFromFolderId(folderId);
    }
}
